import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LegalNoticesService, LegalNotice } from '../../../services/legal-notices.service';
import { BreadcrumbComponent, BreadcrumbItem } from '../../common/breadcrumb/breadcrumb.component';

@Component({
  selector: 'app-bases',
  standalone: true,
  imports: [CommonModule, BreadcrumbComponent],
  templateUrl: './bases.component.html',
  styleUrl: './bases.component.scss'
})
export class BasesComponent implements OnInit {
  legalNotices: LegalNotice[] = [];
  filteredNotices: LegalNotice[] = [];
  tipos: string[] = [];
  selectedTipo: string = '';
  isLoading: boolean = true;
  error: string = '';

  breadcrumbItems: BreadcrumbItem[] = [
    { label: 'Inicio', url: '/' },
    { label: 'Bases Legales' }
  ];

  constructor(private legalNoticesService: LegalNoticesService) {}

  ngOnInit(): void {
    this.loadLegalNotices();
  }

  loadLegalNotices(): void {
    this.isLoading = true;
    this.legalNoticesService.getLegalNotices().subscribe({
      next: (data) => {
        this.legalNotices = data.filter(notice => notice.estado).sort((a, b) => b.orden - a.orden);
        this.tipos = [...new Set(this.legalNotices.map(notice => notice.tipo))];
        // Por defecto seleccionar "Bases Legales Clientes"
        this.filterByTipo('Bases Legales Clientes');
        this.isLoading = false;
      },
      error: (error) => {
        // Para desarrollo, mostrar datos de ejemplo si la API no está disponible
        console.warn('API no disponible, usando datos de ejemplo:', error);
        this.loadMockData();
        this.isLoading = false;
      }
    });
  }

  // Datos de ejemplo para desarrollo
  private loadMockData(): void {
    const mockData: LegalNotice[] = [
      {
        id: 1,
        nombre: "Apertura tu Tarjeta y Obtén tu descuento en Unimarc, Alvi o Mayorista 10",
        url: "https://unipay.cl/api/descargaArchivo/Bases_Legales_Apertura_Tarjeta_Unipay_Unimarc_Alvi_M10.pdf",
        tipo: "Bases Legales Clientes",
        fecha: "2024-06-03",
        estado: true,
        orden: 1
      },
      {
        id: 2,
        nombre: "Activación Clientes Tarjeta Unipay",
        url: "https://unipay.cl/api/descargaArchivo/Bases%20Legales_Activacion%20Clientes%20TU.pdf",
        tipo: "Bases Legales Clientes",
        fecha: "2024-06-03",
        estado: true,
        orden: 2
      },
      {
        id: 3,
        nombre: "Términos y Condiciones Generales",
        url: "https://www.unipay.cl/api/descargaArchivo/20240806_TyC_PdePUnicard_TyC_PdPClubAhorro_VF.pdf",
        tipo: "Bases Legales Otros",
        fecha: "2024-08-06",
        estado: true,
        orden: 3
      },
      {
        id: 4,
        nombre: "Política de Habitualidad",
        url: "https://www.unipay.cl/api/descargaArchivo/politica_habitualidad_unicard.pdf",
        tipo: "Bases Legales Otros",
        fecha: "2024-01-15",
        estado: true,
        orden: 4
      }
    ];

    this.legalNotices = mockData;
    this.tipos = ["Bases Legales Clientes", "Bases Legales Otros"];
    // Por defecto seleccionar "Bases Legales Clientes"
    this.filterByTipo('Bases Legales Clientes');
  }

  filterByTipo(tipo: string): void {
    this.selectedTipo = tipo;
    if (tipo === '') {
      this.filteredNotices = []; // No mostrar nada si no se selecciona un tipo
    } else {
      this.filteredNotices = this.legalNotices.filter(notice => notice.tipo === tipo);
    }
  }

  downloadDocument(url: string): void {
    this.legalNoticesService.downloadDocument(url);
  }

  formatDate(dateString: string): string {
    const date = new Date(dateString);
    return date.toLocaleDateString('es-CL', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  }
}
